import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FiMapPin } from 'react-icons/fi';
import ApartmentCard from '../components/ApartmentCard';
import api from '../services/api';

const LocationDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [location, setLocation] = useState(null);
  const [apartments, setApartments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const data = await api.getLocationBySlug(slug);
        setLocation(data.location);
        setApartments(data.apartments);
      } catch (error) {
        navigate('/locations');
      } finally {
        setLoading(false);
      }
    };
    fetchLocation();
  }, [slug, navigate]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner" />
      </div>
    );
  }

  if (!location) return null;

  const styles = {
    header: {
      background: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url("${location.image || '/images/placeholder-location.jpg'}") center/cover`,
      padding: '100px 24px',
      textAlign: 'center',
      color: 'white'
    },
    title: {
      fontSize: '3rem',
      fontWeight: '700',
      marginBottom: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '12px'
    },
    description: {
      fontSize: '1.125rem',
      opacity: '0.9',
      maxWidth: '700px',
      margin: '0 auto'
    },
    container: {
      maxWidth: '1280px',
      margin: '0 auto',
      padding: '60px 24px'
    },
    sectionTitle: {
      fontSize: '1.5rem',
      fontWeight: '600',
      marginBottom: '24px'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
      gap: '24px'
    },
    empty: {
      textAlign: 'center',
      padding: '60px',
      color: '#555'
    }
  };

  return (
    <>
      <header style={styles.header}>
        <h1 style={styles.title}>
          <FiMapPin />
          {location.name}
        </h1>
        <p style={styles.description}>
          {location.description || `Explore our collection of premium serviced apartments in ${location.name}.`}
        </p>
      </header>

      <section style={styles.container}>
        <h2 style={styles.sectionTitle}>
          {apartments.length} apartment{apartments.length !== 1 ? 's' : ''} in {location.name}
        </h2>

        {apartments.length > 0 ? (
          <div style={styles.grid}>
            {apartments.map(apartment => (
              <ApartmentCard key={apartment._id} apartment={apartment} />
            ))}
          </div>
        ) : (
          <div style={styles.empty}>
            <p>No apartments available in this location yet.</p>
          </div>
        )}
      </section>
    </>
  );
};

export default LocationDetail;
